import { Component, EventEmitter, OnInit, Output, ViewEncapsulation, OnDestroy } from '@angular/core';
import { AppEventDispatcher } from '../../../../utils/AppEventDispatcher';
import { ChangePassEventType } from '../../change-pass.event.type';

@Component({
	selector: 'app-reset-home',
	templateUrl: './reset-home.component.html',
	styleUrls: ['./reset-home.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ResetHomeComponent implements OnInit, OnDestroy {

	@Output() goToResetPage = new EventEmitter<boolean>();

	active = false;

	constructor() { }

	ngOnInit() {
		AppEventDispatcher.listen(ChangePassEventType.STEPS.CHANGE_PASS_RESET_HOME, () => {
			this.active = true;
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(ChangePassEventType.STEPS.CHANGE_PASS_RESET_HOME);
	}

	goToResetWithSteps() {
		this.goToResetPage.emit(true);
		this.active = false;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/change-pass/reset/reset-home/reset-home.component.ts